import getParent from '../selectors';

import { CHART_TAIL_TYPES } from './enums';

export const getTailType = state => getParent(state).chart.tailType;

const isTailSelected = type => state => {
  const { BOTH, CENTER } = CHART_TAIL_TYPES;
  const tailType = getTailType(state);

  return (
    tailType === BOTH || tailType === CENTER ||
    tailType === type
  );
};

export const isLeftTailSelected = isTailSelected(CHART_TAIL_TYPES.LEFT);
export const isRightTailSelected = isTailSelected(CHART_TAIL_TYPES.RIGHT);
export const isBothTailsSelected = isTailSelected(CHART_TAIL_TYPES.BOTH);
export const isCenterSelected = isTailSelected(CHART_TAIL_TYPES.CENTER);

export const isEqualTailSelected = state => getTailType(state) === 'equal';
